import React from 'react'
import {useTranslation} from 'react-i18next'
import {ReloadOutlined} from '@ant-design/icons'
import {Form, Input} from 'antd'
import {IconTitle} from '@/components'
import {generateInvoiceId} from '@/utils'
import {OrderNumberFormFieldProps} from './props'
import {PAYMENT_ORDER_NUMBER, RELOAD_ORDER_NUMBER} from '@/constants/playwright-ids'

export const OrderNumberFormField: React.FC<OrderNumberFormFieldProps> = (props) => {
    const {t} = useTranslation()
    const {prefix = 'PL', tooltipText, onReloadClick, ...rest} = props
    return (
        <Form.Item
            label={
                <IconTitle
                    title={t('OrderNumberFormField.orderNumber')}
                    tooltipText={
                        tooltipText || t('OrderNumberFormField.orderNumberTooltip')
                    }
                />
            }
            name='invoiceId'
            rules={[
                {required: true, message: t('OrderNumberFormField.errors.orderNumberRequired')}
            ]}
            {...rest}
        >
            <Input
                placeholder={t('OrderNumberFormField.orderNumber')}
                data-test-id={PAYMENT_ORDER_NUMBER}
                suffix={
                    <ReloadOutlined
                        onClick={() => onReloadClick(generateInvoiceId(prefix))}
                        data-test-id={RELOAD_ORDER_NUMBER}
                    />
                }
            />
        </Form.Item>
    )
}
